import { observable, flow } from 'mobx'
import { get } from 'common/src/vtj/browser/http'
import { AetTodistuspyyntoStore } from 'todistukset-common/src/vtj/types/form-types.type'

export const createAetTodistuspyyntoStore = (): AetTodistuspyyntoStore => {
  const todistuspyyntoStore: AetTodistuspyyntoStore = observable({
    isLoading: false,
    aetTodistuspyynto: null,
    error: null,
    loadTodistuspyynto: flow(function* (todistuspyyntoId: number) {
      if (todistuspyyntoStore.isLoading) {
        return
      }
      todistuspyyntoStore.isLoading = true
      todistuspyyntoStore.error = null
      todistuspyyntoStore.aetTodistuspyynto = null
      const [err, response] = yield get(
        `/api/restricted/todistukset/aet/order/${todistuspyyntoId}`
      )
      todistuspyyntoStore.isLoading = false
      if (err) {
        todistuspyyntoStore.error = err
      } else {
        todistuspyyntoStore.aetTodistuspyynto = response.data.form
      }
    }),
  })
  return todistuspyyntoStore
}
